import React from 'react'
import infoIcon from '../../../static/images/info-icon.svg'
import { AdvisorTagList } from './AdvisorTagList'
import { AdvisorTag } from './AdvisorTag'
import { AdvisorAdditionalInfo } from './AdvisorAdditionalInfo'
import { Tooltip } from '../../components/Tooltip/Tooltip'
import { useAdvisorCard } from './AdvisorCardContext'
import { ScheduleCallSection } from './ScheduleCallSection'

export const NonRoboAdvisorContent = () => {
  const { advisorData, certifications } = useAdvisorCard()

  return (
    <>
      {advisorData.advisor.expertises && (
        <AdvisorTagList label='Areas of Focus'>
          {advisorData.advisor.expertises.split(',').map((expertise, i) => (
            <AdvisorTag key={i}>{expertise.trim()}</AdvisorTag>
          ))}
        </AdvisorTagList>
      )}
      {certifications.length > 0 && (
        <AdvisorTagList label='Certifications' variant='certifications'>
          {certifications.map((cert, i) => (
            <AdvisorTag key={i} variant='certification'>
              {cert.name}
              <Tooltip content={cert.description}>
                <img src={infoIcon} alt='info'/>
              </Tooltip>
            </AdvisorTag>
          ))}
        </AdvisorTagList>
      )}
      <AdvisorAdditionalInfo />
      <ScheduleCallSection />
    </>
  )
}
